/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ClockPendingIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Clock Pending',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m13.21973,12.65723c-.12891,0-.25977-.0332-.37988-.10352l-3.2207-1.89551c-.22852-.13477-.36914-.38086-.36914-.64648v-5c0-.41406.33594-.75.75-.75s.75.33594.75.75v4.57129l2.85156,1.67773c.35645.20996.47559.66992.26562,1.02734-.13965.2373-.39062.36914-.64746.36914Zm5.05762.20801c.17969-.52246.31055-1.06641.3877-1.61816.05664-.41016-.22949-.78906-.63965-.84668-.41406-.05859-.78906.22949-.84668.63965-.06348.45605-.1709.90527-.31934,1.33691-.13477.3916.07324.81836.46484.95312.08105.02832.16309.04102.24414.04102.31152,0,.60254-.19531.70898-.50586Zm-.32715-4.01465c.40332-.09766.64941-.50293.55176-.90527-.13086-.53809-.31445-1.06641-.5459-1.57129-.17285-.37695-.62207-.54297-.99512-.36816-.37598.17285-.54102.61816-.36816.99512.19141.41699.34375.85352.45215,1.29785.08301.34375.38965.57324.72754.57324.05859,0,.11816-.00684.17773-.02148Zm-1.8916-4.10547c.28516-.29883.27441-.77441-.02539-1.06055-.39844-.37988-.83789-.72559-1.30566-1.02734-.35059-.22461-.81348-.12305-1.03711.22461-.22363.34863-.12305.8125.22461,1.03711.38867.25.75293.53613,1.08301.85156.14453.13867.33105.20703.51758.20703.19727,0,.39551-.07812.54297-.23242Zm-3.81055-2.43945c.07812-.40723-.18848-.7998-.59473-.87793-.54102-.10352-1.09668-.15625-1.65332-.15625h-.06055c-.41406,0-.71973.33594-.71973.75s.36621.75.78027.75c.46191,0,.92285.04395,1.37012.12891.04785.00977.0957.01367.14258.01367.35254,0,.66699-.25.73535-.6084Zm4.36426,13.44531c.27148-.3125.23828-.78613-.0752-1.05762-.31152-.27051-.78516-.23828-1.05762.0752-1.37988,1.59082-3.37695,2.50293-5.47949,2.50293-3.99805,0-7.25-3.25195-7.25-7.25,0-2.9209,1.73828-5.54297,4.42773-6.68164.38184-.16113.56055-.60156.39844-.98242-.16113-.38184-.60449-.56152-.98242-.39844C3.34766,3.33203,1.25,6.49707,1.25,10.02148c0,4.8252,3.9248,8.75,8.75,8.75,2.53809,0,4.94824-1.10059,6.6123-3.02051Z"
      fill="currentColor"
    />
  </svg>`;
};
